import { Button, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

const { media, mediaQueries } = theme;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${mediaQueries.above(media.lg)} {
    width: 35rem;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;

  ${mediaQueries.above(media.lg)} {
    width: 35rem;
  }
`;

export const ItemWrapper = styled.div<{ isReverse?: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  margin: 5rem 0;

  ${mediaQueries.above(media.lg)} {
    flex-direction: ${({ isReverse }) => (isReverse ? 'row-reverse' : 'row')};
  }
`;

export const StyledButton = styled(Button)`
  ${mediaQueries.above(media.lg)} {
    width: 50%;
  }
`;
